function clickedOnTravelerLogin(user) {
    if (user && user.includes('traveler')) {
        return true;
    }
    return false;
}

function clickedOnOwnerLogin(user) {
    if (user && user.includes('owner')) {
        return true;
    }
    return false;
}

module.exports = {
    clickedOnTravelerLogin,
    clickedOnOwnerLogin
};
